// frontend/src/components/StatusBar.jsx
import React from 'react';
import { FaUser, FaCoins, FaHistory } from 'react-icons/fa';
import { GiTwoCoins } from 'react-icons/gi';
import './StatusBar.css';

export default function StatusBar({
  username = 'admin',
  gold = 0,
  silver = 0,
  remaining = 0,
  round = 0,
  score = 0,
  combo = 0,
  onHistoryClick = () => {}
}) {
  return (
    <div className="status-bar">
      <div className="top">
        <div><FaUser className="icon user" />{username}</div>
        <div><FaCoins className="icon gold" />{gold.toFixed(1)}P</div>
        <div><GiTwoCoins className="icon silver" />{silver}</div>
      </div>
      <div className="bottom">
        <div className="stat"><div>剩余转数</div><div>{remaining}</div></div>
        <div className="stat"><div>本轮转数</div><div>{round}</div></div>
        <div className="stat"><div>当前分数</div><div>{score.toFixed(1)}</div></div>
        <div className="stat"><div>连奖次数</div><div>{combo}</div></div>
        <button className="history" onClick={onHistoryClick}>
          <FaHistory /> 历史履历
        </button>
      </div>
    </div>
  );
}